import React, { useState } from 'react';
import join from 'lodash/join';
import ShopifyBuy from '../Shopify/ShopifyBuy';
import ShopifyMoreOptions from '../Shopify/ShopifyMoreOptions';
import { useNurseryContext } from '../../contexts/NurseryContext';
import { setWaterIcons, setSunIcons } from '../Search/SearchResultsItem';
import { AttributeIcon, PlantSize, Zones } from '../../themes/icons/attributes';
var PdpRelatedItem = function (_a) {
    var data = _a.data, onAddToShopifyCart = _a.onAddToShopifyCart, isAvailable = _a.isAvailable;
    var nurserySlug = useNurseryContext().nurserySlug;
    var akaNames = data.aka_names, _b = data.dimensions, H = _b.H, W = _b.W, djangoPk = data.django_pk, photo = data.photo, photoWebp = data.photo_webp, photoDescription = data.photo_description, plantType = data.plant_type, mainTitle = data.primary_name, scientificName = data.scientific_name, slug = data.slug, sunExposure = data.sun_exposure, waterNeeds = data.water_needs, zones = data.zones_str;
    var _c = useState(false), openOptions = _c[0], setOpenOptions = _c[1];
    var relatedUrl = "/plants/".concat(djangoPk, "/").concat(slug, "/");
    if (isAvailable) {
        relatedUrl += "?nurseries=".concat(nurserySlug);
    }
    var scientificNameEl = null;
    if (scientificName) {
        scientificNameEl = (React.createElement("p", { className: "plant__name_scientific" },
            "Scientific Name:",
            ' ',
            scientificName));
    }
    var height = H;
    var width = W;
    var plantSize;
    var heightEl;
    var widthEl;
    if (height) {
        heightEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Height: "),
            React.createElement("span", { className: "value" }, height)));
    }
    if (width) {
        widthEl = (React.createElement("p", null,
            React.createElement("span", { className: "key" }, "Width: "),
            React.createElement("span", { className: "value" }, width)));
    }
    if (height || width) {
        plantSize = (React.createElement("div", { className: "plant__size" },
            React.createElement("h3", null,
                React.createElement(PlantSize, { className: "icn" }),
                "Size"),
            heightEl,
            widthEl));
    }
    var plantPhoto;
    var panelClass = 'panel searchpage__result';
    if (photo !== '') {
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo" },
                React.createElement("picture", null,
                    React.createElement("source", { type: "image/webp", srcSet: photoWebp }),
                    React.createElement("source", { type: "image/jpeg", srcSet: photo }),
                    React.createElement("img", { loading: "lazy", src: photo, alt: photoDescription })),
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    else {
        panelClass += ' noPhoto';
        plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
            React.createElement("div", { className: "plant__photo no_photo" },
                React.createElement("div", { className: "plant__photo_hover" },
                    React.createElement("span", null, "View Plant")))));
    }
    var buyBtn = (React.createElement(ShopifyBuy, { setOpenOptions: setOpenOptions, plant: data, onAddToShopifyCart: onAddToShopifyCart, mainTitle: mainTitle, isAvailable: isAvailable }));
    var waterElem;
    var sunElem = null;
    if ((waterNeeds === null || waterNeeds === void 0 ? void 0 : waterNeeds.length) > 0)
        waterElem = setWaterIcons(waterNeeds);
    if ((sunExposure === null || sunExposure === void 0 ? void 0 : sunExposure.length) > 0)
        sunElem = setSunIcons(sunExposure);
    return (React.createElement("div", { className: panelClass },
        React.createElement("div", { className: "plant__name_cont" },
            React.createElement("h2", { className: "pdp_related__title" },
                React.createElement("a", { href: relatedUrl, title: mainTitle, onBlur: function () { }, onFocus: function () { } }, mainTitle))),
        React.createElement("div", { className: "plant__name_aka" },
            scientificNameEl,
            React.createElement("p", null, akaNames.length > 0 && [
                React.createElement("span", { key: 0 }, "aka "),
                join(akaNames, ', '),
            ])),
        React.createElement("div", { className: "plant__detail" },
            React.createElement("div", { className: "plant__info " },
                React.createElement("div", { className: "plant__type" },
                    React.createElement("h3", null,
                        React.createElement(AttributeIcon, { name: "attr1", className: "icn" }),
                        "Plant Type"),
                    React.createElement("p", null, plantType.replace(/\b[a-z]/g, function (x) { return x.toUpperCase(); }))),
                React.createElement("div", { className: "plant__zones" },
                    React.createElement("h3", null,
                        React.createElement(Zones, { className: "icn" }),
                        "Zones"),
                    React.createElement("p", null, zones)),
                plantSize),
            React.createElement("div", { className: "plant__info_single" },
                React.createElement("ul", { className: "plant__info_needs" },
                    sunElem,
                    waterElem))),
        plantPhoto,
        buyBtn,
        openOptions && (React.createElement(ShopifyMoreOptions, { openOptions: openOptions, setOpenOptions: setOpenOptions, djangoPk: data.django_pk, variants: data.variants.filter(function (variant) { return variant.available; }), affiliatedLinks: data.affiliated_links, onAddToShopifyCart: onAddToShopifyCart, partnersData: data.nurseries, plantTitle: mainTitle }))));
};
export default PdpRelatedItem;
